export enum FmeaTypeEnum {
  AIAG_2008 = 0,
  AIAG_VDA_2019 = 1,
}

export default FmeaTypeEnum;
